import clsx from 'clsx'
import styles from './NavSubItem.module.scss'

export interface INavSubItemProps extends React.HTMLAttributes<HTMLButtonElement> {
  children?: React.ReactNode
  /**
   * Whether the sub-item is active.
   */
  isActive?: boolean
}

export const NavSubItem = ({ children, isActive, ...props }: INavSubItemProps) => {
  return (
    <button className={clsx(styles.navSubItem, { [styles.active]: isActive })} {...props}>
      {children}
    </button>
  )
}
